import { useRef } from "react";
import { useInView, motion } from "motion/react";
import { AnimVals } from "@/utils/animUtils";
import { SOCIAL_ICONS } from "@/core/icons";
import { useViewSize } from '@/providers/ViewSizeContext';

import classNames from "classnames/bind";
import styles from './Footer.module.scss';
const cx = classNames.bind(styles);

type SocialLinksProps = {
  socialLinks: FooterSettings["footerSettingsFields"]["socialLinks"];
};

export default function SocialLinks({ socialLinks }: SocialLinksProps) {
  const linkArr = Object.entries(socialLinks).filter(([key, value]) => value && key !== "__typename");
  const socialOrder = ["instagram", "facebook", "tikTok", "youtube", "substack"];
  linkArr.sort((a, b) => {
    const indexA = socialOrder.indexOf(a[0]);
    const indexB = socialOrder.indexOf(b[0]);
    return indexA - indexB;
  });
  
  // -------------------- Animate In

  const { isDesktop } = useViewSize();

  const isRevealEnabled = false; // TODO: Remove reveal animation code later if not needed -Gabe

  const rootEl = useRef<HTMLDivElement | null>(null);
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });

  const ANIM_OPACITY = AnimVals.opacity;
  const ANIM_DIST = AnimVals.sm.distance;
  const ANIM_DUR = AnimVals.sm.duration;
  const ANIM_DELAY = AnimVals.sm.delay;

  const createMotionProps = (delay: number = 0) => ({
    initial: isRevealEnabled ? { opacity: ANIM_OPACITY, y: ANIM_DIST } : {},
    animate: isInView ? { opacity: 1, y: 0 } : {},
    transition: {
      duration: ANIM_DUR,
      ease: AnimVals.ease,
      delay
    }
  });

  // -------------------- Render

  return (
    <div className={cx("social-links")} ref={rootEl}>
      {linkArr.map(([key, value], index) => {
        const Icon = SOCIAL_ICONS[key] ? SOCIAL_ICONS[key] : null;
        const motionProps = createMotionProps(ANIM_DELAY + index * 0.06);
        return (
          <motion.a
            key={key}
            href={value}
            target="_blank"
            rel="noopener noreferrer"
            className={cx("social-link", key)}
            aria-label={key}
            data-gtm-section="footer"
            {...motionProps}
          >
            {Icon && (
              <span className={cx("icon")}>
                <Icon />
              </span>
            )}
            <div className={cx("social-link__copy")}>
              <p className={cx("cta")}>{key}</p>
              <p className={cx(["text-s", "count"])}>999 Followers</p>
            </div>
          </motion.a>
        );
      })}
    </div>
  );

}
